/**
 * @author Fernando Ruano
 * @file constants.js
 * @description User Constants
 */

// Generic actions
export const GET_USER_LOGIN_INFO = 'User/GET_USER_LOGIN_INFO';
export const GET_USER_DATA_REGISTER = 'User/GET_USER_DATA_REGISTER';
export const GET_VALIDATE_PERMISSION = 'User/GET_VALIDATE_PERMISSION';
export const SET_USER_INFO = 'User/SET_USER_INFO';
export const GET_ALL_USERS = 'User/GET_ALL_USERS';
export const GET_USER_BY_ID = 'User/GET_USER_BY_ID';
export const GET_USER_BY_USERNAME = 'User/GET_USER_BY_USERNAME';
export const GET_USER_BY_EMAIL = 'User/GET_USER_BY_EMAIL';
export const CREATE_USER = 'User/CREATE_USER';
export const UPDATE_USER = 'User/UPDATE_USER';
export const DELETE_USER_BY_ID = 'User/DELETE_USER_BY_ID';
